import type { CpgRetailer } from '@features/campaigns/subdomains/cpg';
import {
  buildProjectedIncrementalSalesChartProps,
  buildTotalProjectedSalesChartProps,
} from '@features/campaigns/subdomains/cpg';
import { donutChartOptions } from '@features/campaigns/subdomains/cpg/configuration/donut-chart-options';
import { getSummaryRetailers } from '@features/campaigns/subdomains/cpg/domain/summary-retailers';
import { chartOptionsToBase64Svg } from '@features/powerpoint';
import type { Slide, TextProps } from '@features/powerpoint';
import type { ValueInput } from '@utils/formattersV2';
import { themeV2 } from '../../../../domain/theme-v2';
import { DEFAULT_FONT } from '../../../../utils/constants-v2';
import { contentSlideHeaderV2 } from '../../../../utils/slide-header-v2';

const CHART_WIDTH = 600;
const CHART_HEIGHT = 600;

type RetailersSummarySlideV2Props = {
  retailers: Pick<
    CpgRetailer,
    | 'name'
    | 'projectedIncrementalSales'
    | 'totalProjectedSales'
    | 'statisticallySignificant'
  >[];
  projectedIncrementalSales: ValueInput;
  totalProjectedSales: ValueInput;
  slideMaster: string;
};

const chartTitleOptions: TextProps['options'] = {
  fontFace: DEFAULT_FONT,
  fontSize: 18,
  bold: true,
  color: themeV2.colors.black,
  align: 'center',
  valign: 'middle',
};

export const retailersSummarySlideV2 = (
  props: RetailersSummarySlideV2Props
): Slide => {
  const filteredRetailers = getSummaryRetailers(props.retailers);

  return {
    slideMaster: props.slideMaster,
    texts: [
      contentSlideHeaderV2('Retailer Summary'),
      {
        text: 'Projected Incremental',
        options: {
          ...chartTitleOptions,
          x: 1.46,
          y: 2.05,
          w: 3.94,
          h: 0.4,
        },
      },
      {
        text: 'Total Projected',
        options: {
          ...chartTitleOptions,
          x: 8.41,
          y: 2.05,
          w: 2.98,
          h: 0.4,
        },
      },
    ],
    images: [
      {
        data: chartOptionsToBase64Svg({
          chartOptions: donutChartOptions(
            buildProjectedIncrementalSalesChartProps(
              filteredRetailers,
              props.projectedIncrementalSales
            )
          ),
          width: CHART_WIDTH,
          height: CHART_HEIGHT,
        }),
        x: 0.48,
        y: 2.47,
        w: 5.9,
        h: 3.61,
      },
      {
        data: chartOptionsToBase64Svg({
          chartOptions: donutChartOptions(
            buildTotalProjectedSalesChartProps(
              filteredRetailers,
              props.totalProjectedSales
            )
          ),
          width: CHART_WIDTH,
          height: CHART_HEIGHT,
        }),
        x: 6.95,
        y: 2.47,
        w: 5.9,
        h: 3.61,
      },
    ],
  };
};
